import { SVGProps, Ref, forwardRef } from 'react'
const SvgColorTikTok = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      fill="#25F4EE"
      d="M10.01 8.995v-.89a6.806 6.806 0 0 0-.95-.08C5.98 8.018 3.251 9.98 2.326 12.869c-.926 2.888.167 6.032 2.696 7.762a6.872 6.872 0 0 1-1.786-3.508 6.806 6.806 0 0 1 .443-3.899 6.943 6.943 0 0 1 2.529-3.035 7.122 7.122 0 0 1 3.802-1.194Z"
    />
    <path
      fill="#25F4EE"
      d="M10.182 19.077c1.723-.002 3.14-1.336 3.215-3.028V.956h2.805A5.088 5.088 0 0 1 16.121 0h-3.838v15.08c-.064 1.7-1.483 3.046-3.214 3.049a3.312 3.312 0 0 1-1.485-.365c.297.404.687.734 1.139.963.451.228.951.348 1.46.35Zm11.261-13v-.84c-1.032.001-2.042-.298-2.902-.86a5.34 5.34 0 0 0 2.902 1.7Z"
    />
    <path
      fill="#FE2C55"
      d="M18.54 4.377A5.142 5.142 0 0 1 17.228.948h-1.025c.132.698.408 1.362.81 1.951.402.59.922 1.093 1.529 1.478Zm-9.48 7.42a3.258 3.258 0 0 0-1.978.68 3.161 3.161 0 0 0-1.134 1.733 3.116 3.116 0 0 0 .192 2.052 3.19 3.19 0 0 0 1.436 1.502 3.113 3.113 0 0 1-.26-3.29 3.18 3.18 0 0 1 1.186-1.258 3.256 3.256 0 0 1 1.68-.464c.322.004.642.053.95.146V9.061a6.843 6.843 0 0 0-.95-.073h-.171v2.918a3.36 3.36 0 0 0-.95-.11Z"
    />
    <path
      fill="#FE2C55"
      d="M21.442 6.077v2.918a9.217 9.217 0 0 1-5.322-1.7v7.668c-.009 3.825-3.167 6.923-7.06 6.923a7.07 7.07 0 0 1-4.039-1.255 7.074 7.074 0 0 0 3.597 2.037 7.16 7.16 0 0 0 4.14-.308 7.025 7.025 0 0 0 3.244-2.544 6.84 6.84 0 0 0 1.224-3.898V8.273a9.233 9.233 0 0 0 5.33 1.678V6.193a5.534 5.534 0 0 1-1.114-.116Z"
    />
    <path
      fill="#000"
      d="M16.119 14.962V7.295a9.217 9.217 0 0 0 5.33 1.678V6.055a5.342 5.342 0 0 1-2.91-1.678 5.272 5.272 0 0 1-1.528-1.478A5.174 5.174 0 0 1 16.2.95h-2.806v15.1a3.133 3.133 0 0 1-.673 1.81c-.41.52-.974.902-1.615 1.092-.641.19-1.326.18-1.96-.03a3.219 3.219 0 0 1-1.58-1.142 3.19 3.19 0 0 1-1.437-1.502 3.115 3.115 0 0 1-.192-2.052c.171-.686.57-1.296 1.134-1.734a3.258 3.258 0 0 1 1.98-.68c.322.003.642.052.95.146V9.039a7.123 7.123 0 0 0-3.825 1.187 6.943 6.943 0 0 0-2.544 3.05 6.805 6.805 0 0 0-.435 3.919 6.873 6.873 0 0 0 1.816 3.516 7.073 7.073 0 0 0 4.045 1.175c3.894 0 7.052-3.098 7.06-6.924Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgColorTikTok)
export default ForwardRef
